import { BuiltInResponseOptionsTab, ResponseOptionsTabs } from '@aon/tws-common-ui-questions';
import React from 'react';
import { useDispatch } from 'react-redux';
import Constants from '../../../constants';
import { ICustomQuestionActionCreators, IValidationResult } from '../../../models';
import { ActionCreators, ICustomQuestionState } from '../../../store/CustomQuestionStore';
import { IUserFeatureAccessHelper } from '../../../utilities/FeatureFlags';
import { ResponseOptionsSelector } from '../response-options';
import { CustomResponseOptionsSection } from './CustomResponseOptionsSection';
import { HierarchyResponseOptionSection } from './HierarchyResponseOptionSection';

interface ICustomResponseOptionGroupTabsProps {
	responseOptionValidation?: IValidationResult;
}

export type CustomDemographicQuestionParams = ICustomQuestionActionCreators &
	ICustomQuestionState &
	ICustomResponseOptionGroupTabsProps & { userFeatureAccessHelper: IUserFeatureAccessHelper };

export function CustomResponseOptionGroupTabs(props: CustomDemographicQuestionParams) {
	const { question, responseOptionGroupsLoading, responseOptionsGroupTabKey, responseOptionValidation } = props;
	const dispatch = useDispatch();

	function TabChange(tabKey: string) {
		dispatch(ActionCreators.HandleResponseOptionsGroupTabChange(tabKey));
	}

	const getResponseOptionsTabItems = () => {
		return [
			{
				type: BuiltInResponseOptionsTab.Standard,
				component: (
					<ResponseOptionsSelector
						{...props}
						sectionContainer={'div'}
						loading={responseOptionGroupsLoading}
						validationResult={responseOptionValidation}
						questionDimensions={question.dimensions}
						originalQuestionSourceReponseOptionGroupId={question.sourceResponseOptionGroupId}
					/>
				),
			},
			{
				type: BuiltInResponseOptionsTab.Custom,
				component: (
					<CustomResponseOptionsSection
						{...props}
						isDemographic={false}
						sectionContainer={'div'}
						name={props.responseOptionGroupName}
						validationResults={props.validationResults}
					/>
				),
			},
			{
				tabKey: Constants.RESPONSE_OPTION_GROUP_TAB_HIERARCHY,
				description: Constants.RESPONSE_OPTION_GROUP_TAB_HIERARCHY_RESPONSE,
				warningMessage: Constants.RESPONSE_OPTION_GROUP_TAB_HIERARCHY_WARNING_MESSAGE,
				component: (
					<HierarchyResponseOptionSection
						{...props}
						sectionContainer={'div'}
						surveyId={question.surveyId}
						hierarchyId={question.hierarchyId}
					/>
				),
			},
		];
	};

	return (
		<ResponseOptionsTabs
			activeKey={responseOptionsGroupTabKey ?? Constants.RESPONSE_OPTION_GROUP_TAB_STANDARD}
			responseOptionsTabItems={getResponseOptionsTabItems()}
			tabChange={TabChange}
		/>
	);
}
